export class HttpErrorsObserver {
  static $inject = ['$q', '$location', 'toastr'];

  constructor(
    private $q,
    private $location,
    private toastr,
  ) { }

  responseError(errorResponse) {
    switch (errorResponse.status) {
      case 401:
        if (errorResponse.config.url !== '/api/account') {
          this.$location.url(
            '/login?error=' +
            window.encodeURIComponent("Vous n'êtes pas connecté"),
          );
        }
        break;
      case 403:
        this.toastr.error(
          "Vous n'êtes pas autorisé à réaliser cette action. Contacter votre administrateur",
        );
        break;
      case 500:
        this.toastr.error("Une erreur s'est produite : " + errorResponse);
        break;
    }
    return this.$q.reject(errorResponse);
  }
}
